<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>运营工具</el-breadcrumb-item>
      <el-breadcrumb-item>发短信</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <el-form
        :model="model"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="100px"
      >
        <el-form-item label="模板" prop="template_code">
          <el-select
            size="small"
            v-model="model.template_code"
            placeholder="请选择短信模板"
          >
            <el-option
              v-for="item in templates"
              :key="item.name"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          <div v-if="selectedTemplate">{{ selectedTemplate.content }}</div>
        </el-form-item>
        <el-form-item label="发送对象" prop="targets">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAllUser"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <el-checkbox-group
            v-model="model.targets"
            @change="handleCheckedUsersChange"
          >
            <div v-for="du in dealerUsers" class="dealer-item">
              <div class="dealer-name">{{ du.dealer.name }}</div>
              <div class="dealer-users">
                <el-checkbox
                  v-for="u in du.users"
                  :label="u.phone_number"
                  :key="u.phone_number"
                  >{{ u.name }}</el-checkbox
                >
              </div>
            </div>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="">
          <el-button
            :disabled="submiting"
            type="primary"
            size="small"
            @click="sendCustomSMS"
            >发 送</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { dealerUsers, sendSms, smsTemplates } from '../../service/getData'
export default {
  data() {
    return {
      model: {
        template_code: null,
        targets: [],
      },
      checkAllUser: false,
      isIndeterminate: false,
      templates: [],
      dealerUsers: {},
      submiting: false,
      rules: {
        template_code: [
          { required: true, message: '请选择短信模板', trigger: 'change' },
        ],
        targets: [
          { required: true, message: '请选择发送对象', trigger: 'change' },
        ],
      },
    }
  },
  created() {
    this.requestTemplates()
    this.requestDealerUsers()
  },
  computed: {
    selectedTemplate() {
      let s = this.templates.filter((t) => {
        return t.code == this.model.template_code
      })
      if (s.length == 1) {
        return s[0]
      } else {
        return null
      }
    },
    allUsers() {
      let users = []
      for (const key in this.dealerUsers) {
        const du = this.dealerUsers[key]
        du.users.map((u) => {
          users.push(u.id)
        })
      }
      return users
    },
  },
  methods: {
    async requestTemplates() {
      let res = await smsTemplates()
      if (res.code == 0) {
        this.templates = res.data.list
      }
    },
    async requestDealerUsers() {
      let res = await dealerUsers()
      if (res.code == 0) {
        let users = res.data.list
        let dealers = {}
        users.map((item) => {
          if (!dealers[item.dealer_id]) {
            dealers[item.dealer_id] = {
              dealer: item.dealer,
              users: [],
            }
          }
          dealers[item.dealer_id].users.push(item)
        })
        this.dealerUsers = dealers
      }
    },
    async sendCustomSMS() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let that = this
          sendSms(this.model).then((res) => {
            if (res.code == 0) {
              that.$alert('短信已发送', {
                callback: (action) => {
                  that.$router.push('/dashboard/sms/records')
                },
              })
            }
            that.submiting = false
          })
        }
      })
      // let res = await sendSms(this.model)
      // if (res.code == 0) {
      //   this.$alert('短信已发送', {
      //     callback: (action) => {
      //       that.$router.push('/dashboard/sms/records')
      //     },
      //   })
      // }
    },
    handleCheckAllChange(val) {
      this.model.targets = val ? this.allUsers : []
      this.isIndeterminate = false
    },
    handleCheckedUsersChange(val) {
      let checkedCount = val.length
      this.checkAll = checkedCount === this.allUsers.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.allUsers.length
    },
  },
}
</script>

<style  scoped>
.dealer-item {
  display: flex;
}
.dealer-name {
  font-size: 12px;
  width: 300px;
  margin-right: 20px;
  line-height: 1.5;
}
.dealer-users {
  display: flex;
}

.dealer-users .el-checkbox {
  width: 120px !important;
}

/deep/ .el-checkbox {
  font-size: 12px;
}
/deep/ .el-form-item__content {
  line-height: 30px;
}
/deep/ .el-checkbox__label {
  font-size: 12px;
}
</style>